export const ADD_AREAS = 'ADD_AREAS'
